// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__HI2TQ","colMin":"styles_colMin__2hdzS"};